import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/holiday-rules', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/holiday-rules', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put('/api/holiday-rules/0', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubstitute = (Options = {}) => {
  return httpClient
    .get('/api/holiday-rule/substitute-day', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  update,
  getSubstitute
}
